import { ActivationGroup } from "@/types/calculators";

export const activationGroups: ActivationGroup[] = [
  {
    key: "qimen",
    activationKeys: [
      "dragon",
      "generals",
      // "ding_general",
      // "bing_general",
      // "yi_general",
      // "triple_victory_formation",
      "bird",
    ],
  },
  // {
  //   key: "stars",
  //   activationKeys: [
  //     "gui_ren",
  //     "academical_star",
  //     "personal_academician_star",
  //     "personal_horse",
  //   ],
  // },
  {
    key: "noble_helpers",
    activationKeys: [
      "noble_helpers_sun",
      "noble_helpers_moon",
      "noble_helpers_happy_noble",
    ],
  },
  {
    key: "pushing_people_into",
    activationKeys: ["pushing_people_into"],
  },
  {
    key: "warming_money_star",
    activationKeys: ["warming_money_star"],
  },
  // {
  //   key: "lady_and_girl",
  //   activationKeys: ["lady_and_girl"],
  // },
  // {
  //   key: "human_structure",
  //   activationKeys: ["human_structure"],
  // },
  // {
  //   key: "immortal_structure",
  //   activationKeys: ["immortal_structure"],
  // },
  // {
  //   key: "ghost_structure",
  //   activationKeys: ["ghost_structure"],
  // },
  // {
  //   key: "three_pretence",
  //   activationKeys: ["three_pretence"],
  // },
  // {
  //   key: "personal_b_c",
  //   activationKeys: ["personal_b_c"],
  // },
  // {
  //   key: "one_six_eight",
  //   activationKeys: ["one_six_eight"],
  // },
  // {
  //   key: "four_horses",
  //   activationKeys: ["four_horses"],
  // },
  // {
  //   key: "strengthening_health",
  //   activationKeys: ["strengthening_health"],
  // },
];
